import React, { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
import { createModal } from "../hooks/createModal";
import Confirm from "../popups/Confirm";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { useTabs} from "../hooks/useTabs";
import { showMessage } from "../ui/Message";
import Input from "../ui/Input";

export default function GLAccounts(props) {

    const NEW_ROW = { account: "", __new: true };

    const { controller = "", route = "", search = "", callback = () => { } } = props;

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("auto");
    const [loading, setLoading] = useState(false);

    const [state, setState] = useState({
        edit: false,
        new: false,
    })

    const tableData = state.new ? [...data, NEW_ROW] : data;

    const isNewRow = (row) => row?.__new === true || row?.account === "";

    const defaultTabs = [
        { label: "Account", key: "account", value: ""},
        { label: "Description", key: "description", value: "" },
        { label: "Resrvd", key: "reserved", value: "" },
        { label: "Se", key: "entry_section", value: "" },
        { label: "Lo", key: "entry_location", value: "" },
        { label: "Se", key: "statement_section", value: "" },
        { label: "Lo", key: "statement_location", value: "" },
        { label: "Se", key: "quick_book", value: ""},
    ]
    
    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "account");

    const showEditRow = () => {
        if (selected?.account) {
            setTabs([
                { label: "account", key: "account", value: selected.account || "" },
                { label: "description", key: "description", value: selected.description || "" },
                { label: "Resrvd", key: "reserved", value: selected.reserved || "" },
                { label: "entry_section", key: "entry_section", value: selected.entry_section === true ? "Y" : (selected.entry_section === false ? "N" : "") },
                { label: "entry_location", key: "entry_location", value: selected.entry_location === true ? "Y" : (selected.entry_location === false ? "N" : "") },
                { label: "statement_section", key: "statement_section", value: selected.statement_section === true ? "Y" : (selected.statement_section === false ? "N" : "") },
                { label: "statement_location", key: "statement_location", value: selected.statement_location === true ? "Y" : (selected.statement_location === false ? "N" : "") },
                { label: "quick_book", key: "quick_book", value: selected.statement_location === true ? "Y" : (selected.statement_location === false ? "N" : "")  },
            ]);
            setState(s => ({ ...s, edit: true, new: false }));
            setIndex("account");
            requestAnimationFrame(() => {
                refs.current?.account?.focus?.();
            });
        }
    }

    const drawMessage = () => {
        switch (index) { 
            case "account": return <>A unique GL account number</>;
            case "description": return <>A description of this GL account</>;
            case "entry_section": return <>If Sales/Receiving postings are broken down by Section codes (Yes/No)</>;
            case "entry_location": return <>If Sales/Receiving postings are broken down by Location codes (Yes/No)</>;
            case "statement_section": return <>If statements detail Acct by Section codes (Yes/No)</>;
            case "statement_location": return <>If statements detail Acct by Location (Yes/No)</>;
            case "quick_book": return <>Y/N if QuickBooks export adds the Section name to the Account name</>;
        }
    }

    const cancelEditRow = () => {
        setState(s => ({ ...s, edit: false, new: false }));
        setTabs(defaultTabs);
    }

    const edit_nav = [
        { key: KBD.ESCAPE, action: () => { cancelEditRow() } },
        { key: KBD.ENTER, action: () => index === "description" ? setIndex("entry_section") : index === "quick_book" ? saveGL() : next() },
        { key: KBD.TAB, action: () => {index === "description" ? setIndex("entry_section") : next() } },
        { key: KBD.PAGE_DOWN, action: () => { saveGL() } },
        { key: KBD.ARROW_DOWN, action: () => { index === "description" ? setIndex("entry_section") : next() }},
        { key: KBD.ARROW_UP, action: () => { index === "entry_section" ? setIndex("description") : prev() }}, 
    ]

    const nav = [
        { key: KBD.D, text: "Del", action: (e) => { removeAccount() } },
        { key: KBD.E, text: "Edt", action: (e) => { showEditRow() } },
        { key: KBD.N, text: "New", action: (e) => { showNewRow() } },
        { text: "Prt" },
        { key: KBD.ESCAPE, action: (e) => { callback(false) } },
        { key: KBD.ENTER, action: (e) => { callback(selected) } },
        { key: KBD.ARROW_DOWN, action: (e) => { nextGL() } },
        { key: KBD.ARROW_UP, action: (e) => { prevGL() } },
    ]
    
    useEffect(() => {
        const actions = (state.new || state.edit) ? edit_nav : nav;
        const cleanup = listen(controller, route, actions, false, [KBD.D, KBD.E, KBD.TAB, KBD.N, KBD.ESCAPE, KBD.ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.PAGE_DOWN ]);
        return cleanup;
    }, [index, tabs, refs, state.new, state.edit, selected, data])

    const saveGL = () => {
        const _info = {
            account: getVal("account"),
            description: getVal("description"),
            reserved: selected?.reserved || false, 
            entry_section: getVal("entry_section") === "Y" ? true : (getVal("entry_section") === "N" ? false : null),
            entry_location: getVal("entry_location") === "Y" ? true : (getVal("entry_location") === "N" ? false : null),
            statement_section: getVal("statement_section") === "Y" ? true : (getVal("statement_section") === "N" ? false : null),
            statement_location: getVal("statement_location") === "Y" ? true : (getVal("statement_location") === "N" ? false : null),
            quick_book: getVal("quick_book") === "Y" ? true : (getVal("quick_book") === "N" ? false : null),
        }

        if (state.edit) {
            pubCall("general_ledger.editAccount", { account_info: _info }, (_s, _r) => {
                if (_s) {                      
                    showMessage("Account updated");
                    setState(s => ({ ...s, edit: false, new: false }));
                    getAllAccounts();
                } else {
                    showError(_r);
                }
            })
        } else if (state.new) {
            pubCall("general_ledger.createAccount", { account_info: _info }, (_s, _r) => {
                if (_s) {
                    showMessage("Account added");
                    setState(s => ({ ...s, edit: false, new: false }));
                    getAllAccounts();
                } else {
                    showError(_r);
                }
            })
        }
    };

    const showNewRow = () => { 
        setState(s => ({ ...s, edit: false, new: true}));
        setSelected(NEW_ROW);
        setIndex("account");
        requestAnimationFrame(() => {
            refs.current?.account?.focus?.();
        })
    };

    useEffect(() => {
        if (!state.new && !state.edit) return;
        requestAnimationFrame(() => {
            const el = refs?.current[index];
            if (el) el.focus();
        });
    }, [index]);


    const canEditRow = (row) => {
        if (isNewRow(row) && state?.new) return true;

        if (state?.edit && row?.account === selected?.account) return true;

        return false;
    }

    const isYes = (_bool) => {
        return (_bool) ? <small style={{ "color": "var(--text)" }}>Yes</small> : <small style={{ "color": "var(--text-dim)" }}>No</small>;
    }

    const nextGL = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const nextIndex = data.findIndex(item => item?.account === selected?.account) + _rows;
        if (data.length <= nextIndex) { setSelected(data[0]); }
        if (nextIndex < data.length) { setSelected(data[nextIndex]); }
    };
    const prevGL = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.account === selected?.account) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return; }
        if (prevIndex >= 0) { setSelected(data[prevIndex]); }
    };

    const getIndex = (_search = "", _data) => {
        if (!_search) {
            return 0;
        }
        let _index = _data.findIndex(obj => {
            const accountNumber = obj.account.toString();
            return accountNumber.startsWith(_search.toString());
        });

        return _index; 
    }

    const removeAccount = () => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} events={[KBD.D, KBD.U]} title={"Remove GL Account?"} route={ROUTES.HELPERS.CONFIRM}/>, closable:true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    pubCall("general_ledger.deleteAccount", { account: selected.account }, (_s, _r) => {
                        if (!_s) return showError(_r);
                        const newData = data.filter(item => item.account !== selected.account);
                        setData(newData);
                        if (newData.length > 0) { 
                            setSelected(newData[0]); 
                        } else { 
                            setSelected({}) 
                        }
                    })
                }
            }
        })
    }

    const columns = [
        { key: "account", align: "center", title: <>Account</>, width: 55, render: (e, f) => {
            if (canEditRow(f)) {
                return <Input maxLength={3} tabMax={() => next()} className="fill" {...editProps("account")} />
            } else {
                return <>{f.account}</>
            }
        }},
        { key: "description", align: "left", title: <>Description</>, width: 365, render: (e, f) => {
            if (canEditRow(f)) {
                return <Input maxLength={30} tabMax={() => next()} className="fill" {...editProps("description")} style={{ "width": "365px", "textAlign": "left" }} />
            }
            return <>{f.description}</>
        }},
        { key: "reserved", align: "left", title: <>Resrvd</>, width: 53, render: (e, f) => {
                return e;
        }},
        { key: "entry_section", align: "left", title: <>Se</>, width: 40, render: (e, f) => {
            if (canEditRow(f)) {
                return <Input maxLength={1} tabMax={() => next()} uppercase={true} chars={["Y", "N"]} className="fill" {...editProps("entry_section")} />
            } else {
                return isYes(f.entry_section);
            }
        }},
        { key: "entry_location", align: "left", title: <>Lo</>, width: 40, render: (e, f) => {
            if (canEditRow(f)) {
                return <Input maxLength={1} tabMax={() => next()} uppercase={true} chars={["Y", "N"]} className="fill" {...editProps("entry_location")} />
            } else {
                return isYes(f.entry_location);
            }
        }},
        { key: "statement_section", align: "left", title: <>Se</>, width: 40, render: (e, f) => {
            if (canEditRow(f)) {
                return <Input maxLength={1} tabMax={() => next()} uppercase={true} chars={["Y", "N"]} className="fill" {...editProps("statement_section")} />
            } else {
                return isYes(f.statement_section);
            }
        }},
        { key: "statement_location", align: "left", title: <>Lo</>, width: 40, render: (e, f) => {
            if (canEditRow(f)) {
                return <Input maxLength={1} tabMax={() => next()} uppercase={true} chars={["Y", "N"]} className="fill" {...editProps("statement_location")} />
            } else {
                return isYes(f.statement_location);
            }
        }},
        { key: "quick_book", align: "left", title: <>Se</>, width: 121, render: (e, f) => {
            if (canEditRow(f)) {
                return <Input maxLength={1} tabMax={() => next()} uppercase={true} chars={["Y", "N"]} className="fill" {...editProps("quick_book")} />
            }
            return isYes(f.statement_location);
        }},
    ]

    const getAllAccounts = () => {
        pubCall("general_ledger.getAllAccounts", {}, (_s, _r) => {
            if (_s) {
                setData(_r);
                let _index = getIndex(search, _r); 
                setSelected(_r.length > 0 ? _r[_index] : {});
            } else {
                showError(_r);
            }
        })
    }

    useEffect(getAllAccounts, [])

    const drawHeader = () => {
        return (
            <Space>
                <div style={{ "width": "460px" }}></div>
                <div className="ReactVirtualized__Table__headerColumn">&nbsp;</div>
                <div style={{ "width": "75px", "justifyContent": "start" }} className="ReactVirtualized__Table__headerColumn">Entries</div>
                <div style={{ "width": "75px", "justifyContent": "start" }} className="ReactVirtualized__Table__headerColumn">Statements</div>
                <div style={{ "width": "70px", "justifyContent": "start" }} className="ReactVirtualized__Table__headerColumn">Quickbooks</div>
            </Space>
        )
    }

    return (
        <>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                header={drawHeader()}
                onWheel={(e) => (e.deltaY > 0) ? nextGL() : prevGL()}
                onRowClick={(item, event, index) => setSelected(item)}
                onRowDoubleClick={(item) => callback(item)}
                next={nextGL}
                prev={prevGL}
                row_key="account"
                align="auto"
                tweak={60}
                route={route}
                current={selected}
                offset={0}
                height={388}
                data={tableData}
                columns={columns}
                width={762}
            />
            <div className="shim" style={{ "height": "4px" }} />
            {(state.new || state.edit) && <Status type="active"><InfoIcon />{drawMessage()}</Status>}
            {(!state.new && !state.edit) && <div style={{ "marginBottom": "-8px" }}><Nav nav={nav} /></div>}
        </>
    )
}